var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-2",attrs:{"fluid":"","grid-list-sm":""}},[_c('MainContent',{attrs:{"type_object":"chapter"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }